import { Grid, Typography, Box } from '@mui/material';

import { ReactComponent as Regenerate } from 'common/assets/images/ai-generate.svg';
import ButtonComp from 'common/components/Button/ButtonComp';

import styles from './RegenerateSummaryDailogue.module.scss';

interface IMappingConfirmationDailog {
	cancelClicked?: any;
	submitClicked?: any;
}

const RegenerateSummaryDailog = (props: IMappingConfirmationDailog) => {
	const { cancelClicked, submitClicked } = props;

	const item = {
		id: 1,
		value:
			'This will delete all generated items that haven’t been manually added. This process may take up to 2-5 minutes.',
	};

	return (
		<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
			<Grid container direction="column" gap="12px">
				<Typography className={styles['regenerate-modal-heading']}>
					Confirm Regenerate
				</Typography>
				<Grid
					container
					direction="row"
					alignItems="normal"
					className={styles['stack-background']}
				>
					<Grid
						item
						xs={12}
						sm={12}
						md={12}
						lg={12}
						xl={12}
						display="flex"
						alignItems="flex-start"
						key={item.id}
						className={styles['regenerate-modal-sub-text-grid']}
					>
						<Typography className={styles['regenerate-modal-sub-text']}>
							{item.value}
						</Typography>
					</Grid>
				</Grid>
				<Grid
					item
					display="flex"
					alignItems="flex-end"
					justifyContent="flex-end"
					gap="10px"
				>
					<ButtonComp btnType="secondary" clickHandler={cancelClicked}>
						Cancel
					</ButtonComp>
					<ButtonComp
						btnType="secondary"
						compClass={styles['regenerate-button']}
						startIcon={
							<Box className={styles['regenerate-button-icon']}>
								<Regenerate />
							</Box>
						}
						clickHandler={submitClicked}
						data-testid="regenerate-button-confirm"
					>
						Regenerate
					</ButtonComp>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default RegenerateSummaryDailog;
